<template>
  <div style="height: 100%;width:99.9%;">
    <div class="bigtitle" >合肥光源软X射线磁性圆二色实验站运行状态</div>
    <div align="center" class="top-ul" :style="{height:computeHeight + 'px'}">
      <div class="boxLeft">
        <div class="block one" :style="{height:0.48*computeHeight + 'px'}" >
          <div class="title" >合肥光源运行状态</div>
          <div class="box">
            <div class="shiyanUl">
              <div class="shiyanliLeft">
                <div class="shiyanli" :style="{'line-height':0.45*computeHeight*0.13 + 'px'}">
                  <div class="shiyanliname">运行计划:</div>
                  <div class="shiyanlitxt">{{status.operationMode}}</div>
                </div>
                <div class="shiyanli" :style="{'line-height':0.45*computeHeight*0.13 + 'px'}">
                  <div class="shiyanliname">运行状态:</div>
                  <div class="shiyanlitxt">{{status.operationStatus}}</div>
                </div>
                <div class="shiyanli" :style="{'line-height':0.45*computeHeight*0.13 + 'px'}">
                  <div class="shiyanliname">束流流强:</div>
                  <div class="shiyanlitxt">{{status.beamCurrent}}</div>
                </div>
                <div class="shiyanli" :style="{'line-height':0.45*computeHeight*0.13 + 'px'}">
                  <div class="shiyanliname">束流寿命:</div>
                  <div class="shiyanlitxt">{{status.lifetime}}</div>
                </div>
                <div class="shiyanli" :style="{'line-height':0.45*computeHeight*0.13 + 'px'}">
                  <div class="shiyanliname">束流能量:</div>
                  <div class="shiyanlitxt">{{status.energy}}</div>
                </div>
              </div>
            </div>  
          </div>
        </div>
         <div class="block three" :style="{height:0.48*computeHeight + 'px'}">
            <div class="title" >24小时束流流强</div>
            <highcharts :options='options' style="margin-top:15px;"></highcharts>
          </div>
      </div>
      <div class="boxMiddle">
      <div class="block two" :style="{height:0.97*computeHeight + 'px'}">
          <div class="title" >束斑信息</div>
          <div class="box" > 
            <div :style="{height:0.97*computeHeight *0.39+ 'px'}" style="width:64%;">
              <!--<highcharts :options='optionsTwo' style="margin-top:15px;" constructor-type="stockChart"></highcharts>-->
              <img :src="imgUrl"  width="100%" height="100%">
             </div> 
            <div class="shiyanUl">
              <div class="shiyanliLeft">
                 <div class="shiyanli" :style="{'line-height':0.45*computeHeight*0.15 + 'px'}">
                  <div class="shiyanliname">束斑水平尺寸:</div>
                  <div class="shiyanlitxt">{{status.Hsize}}</div>
                </div>
                <div class="shiyanli" :style="{'line-height':0.45*computeHeight*0.15 + 'px'}">
                  <div class="shiyanliname">水平发射度:</div>
                  <div class="shiyanlitxt">{{status.Hemittance}}</div>
                </div>
                <div class="shiyanli" :style="{'line-height':0.45*computeHeight*0.15 + 'px'}">
                  <div class="shiyanliname">束斑垂直尺寸:</div>
                  <div class="shiyanlitxt">{{status.VSize}}</div>
                </div>
                <div class="shiyanli" :style="{'line-height':0.45*computeHeight*0.15 + 'px'}">
                  <div class="shiyanliname">垂直发射度:</div>
                  <div class="shiyanlitxt">{{status.Vemittance}}</div>
                </div>
                <div class="shiyanli" :style="{'line-height':0.45*computeHeight*0.15 + 'px'}">
                  <div class="shiyanliname">束流水平轨道:</div>
                  <div class="shiyanlitxt">{{status.x}}</div>
                </div>
                <div class="shiyanli" :style="{'line-height':0.45*computeHeight*0.15 + 'px'}">
                  <div class="shiyanliname">束流垂直轨道:</div>
                  <div class="shiyanlitxt">{{status.y}}</div>
                </div>
              </div>
            </div>  
          </div>
        </div>
     
      </div>
      <div class="boxRight">
         <div class="block two" :style="{height:0.64*computeHeight + 'px'}">
          <div class="title" >实验及课题信息</div>
          <div class="box" > 
            <div class="shiyanUl">
              <div class="shiyanliLeft">
                <div class="shiyanli" :style="{'line-height':0.45*computeHeight*0.13 + 'px'}">
                  <div class="shiyanliname">实验用户:</div>
                  <div class="shiyanlitxt">{{status.exUser}}</div>
                </div>
                 <div class="shiyanli" :style="{'line-height':0.45*computeHeight*0.13 + 'px'}">
                  <div class="shiyanliname">本次实验总机时:</div>
                  <div class="shiyanlitxt">{{status.totalBeamtime}}</div>
                </div>
                <div class="shiyanli" :style="{'line-height':0.45*computeHeight*0.13 + 'px'}">
                  <div class="shiyanliname">本次实验剩余机时:</div>
                  <div class="shiyanlitxt">{{status.leftBeamtime}}</div>
                </div>
                <div class="shiyanli" :style="{'line-height':0.45*computeHeight*0.13 + 'px'}">
                  <div class="shiyanliname">课题提案号:</div>
                  <div class="shiyanlitxt">{{status.proposal}}</div>
                </div>
                <div class="shiyanli" :style="{'line-height':0.45*computeHeight*0.13 + 'px'}">
                  <div class="shiyanliname">实验开始时间:</div>
                  <div class="shiyanlitxt">{{status.start}}</div>
                </div>
                <div class="shiyanli" :style="{'line-height':0.45*computeHeight*0.13 + 'px'}">
                  <div class="shiyanliname">实验结束时间:</div>
                  <div class="shiyanlitxt">{{status.end}}</div>
                </div>
                <div class="shiyanli" :style="{'line-height':0.45*computeHeight*0.13 + 'px'}">
                  <div class="shiyanliname">课题名称:</div>
                </div>
              </div>
            </div>  
            <div class="shiyanname">
                <div class="longtxt">{{status.name}}</div>
            </div>
          </div>
        </div>
        <div class="block four" :style="{height:0.32*computeHeight + 'px'}">
         <div class="title" >实验站运行状态</div>
          <div class="shiyanUl">
            <div class="shiyanliLeft">
              <div class="shiyanli" :style="{'line-height':0.45*computeHeight*0.18 + 'px'}">
                <div class="shiyanliname">光闸状态:</div>
                <div class="shiyanlitxt">{{status.bsStatus}}</div>
              </div>
              <div class="shiyanli" :style="{'line-height':0.45*computeHeight*0.18 + 'px'}">
                <div class="shiyanliname">单色器能量:</div>
                <div class="shiyanlitxt">{{status.p2e}}eV</div>
              </div>
            </div>
            <div class="shiyanliRight">
              <div class="shiyanli" :style="{'line-height':0.45*computeHeight*0.18 + 'px'}">
                <div class="shiyanliname">金网电流:</div>
                <div class="shiyanlitxt">{{status.io}}A</div>
              </div>
              <div class="shiyanli" :style="{'line-height':0.45*computeHeight*0.18 + 'px'}">
                <div class="shiyanliname">样品电流:</div>
                <div class="shiyanlitxt">{{status.is}}A</div>
              </div>
            </div>
          </div>
        </div>
      </div> 
    </div>
  </div>
</template>


<script>

  export default {
    name: "home",
    computed:{
      computeHeight(){
        return this.wrapH
      }
    },
    data() {
      return {

        switchValue1: false,

        ws: null,

        status: {
          operationMode: "",
          beamCurrent: "",
          lifetime: "",
          operationStatus: "",
          energy: "",
          exUser:"",
          proposal:"",
          start:"",
          name:"",
          end:"",
          p2e:"",
          io:0,
          is:0,
          totalBeamtime:"",
          leftBeamtime:"",
          bsStatus:"",

          Hsize:null,
          Hemittance:null,
          VSize:null,
          Vemittance:null,
          x:null,
          y:null
        },

        options: {
          chart: {
            backgroundColor: '#eef3f7',
            width: 600,
            height: 450,
            zoomType: null,
            enabled: false,
            plotBorderWidth: 2,
            plotBorderColor: 'grey',
            animation: false           //关闭渲染动画
          },
          plotOptions: {

            series: {
              turboThreshold: 10000,   //最大渲染点数
              animation: false,       //关闭渲染动画
            },
            line: {
              dataGrouping: {
                enabled: false        //关闭数据分组显示，确保页面显示所有数据
              }
            }
          },
          title: {
            text: null
          },
          xAxis: {
            gridLineDashStyle: 'ShortDash',
            gridLineWidth: 1,
            lineColor: 'grey',
            ordinal: false,
            type: 'datetime',
            title: {
              text: 'Time',
              style: {
                color: "black",
                fontWeight: 1000,
              }
            },
            dateTimeLabelFormats: {
              millisecond: '%H:%M:%S.%L',
              second: '%H:%M:%S',
              minute: '%H:%M',
              hour: '%m-%d %H:%M',
              day: '%m-%d %H:%M',
              week: '%m-%d %H:%M',
              month: '%Y-%m-%d %H:%M',
              year: '%Y'
            },
            tickInterval: 4 * 60 * 60 * 1000,
            // endOnTick:true,
            max: new Date().getTime(),
            min: new Date(Date.now() - 24 * 1000 * 60 * 60).getTime()
          },
          yAxis: [{
            // gridLineDashStyle:'ShortDash',
            gridLineWidth: 0,
            lineColor: 'grey',
            showFirstLabel: true,    //显示坐标轴第一个点
            showLastLabel: true,      //显示最后一个点
            opposite: false,             //坐标轴位置
            type: 'linear',
            title: {
              text: 'Beam Current(mA)',
              style: {
                color: "black",
                fontWeight: 1000
              }
            },
            lineWidth: 2,
            // tickPositioner: function () {
            //   console.log(this.tickPositions)
            //   let n = this.tickPositions.length;
            //   if(Math.abs(this.tickPositions[0]-this.tickPositions[n-1])>=150){
            //     let p = this.tickPositions[n-1];
            //     let interval = Math.ceil(Math.ceil(p / 5)/10)*10
            //     return [0, interval, 2 * interval, 3 * interval, 4 * interval,5*interval];
            //   } else if(this.tickPositions[0] > 190 && this.tickPositions[n-1] < 370) {
            //     return [180, 220, 260, 300, 340, 380]
            //   } else if (this.tickPositions[0] < 190 && this.tickPositions[n-1] < 400 && Math.abs(this.tickPositions[0]-this.tickPositions[n-1])>=100) {
            //     return [0, 80, 160, 240, 320, 400]
            //   }else if(this.tickPositions[0] < 1){
            //     let p = new Array();
            //     if(n < 6){return this.tickPositions;  }
            //     for (let i = 0; i < 6; i++){
            //       console.log(parseFloat(this.tickPositions[i]).toFixed(4))
            //       // console.log(Highcharts.numberFormat(1.2345,2))
            //       p.push(parseFloat(this.tickPositions[i]))
            //     }
            //     return p;
            //   }else {
            //     return this.tickPositions;
            //   }
            // }
            startOnTick: false,
            min: 0,
            // max:350
          },
            {
              gridLineWidth: 0,
              lineColor: 'grey',
              showFirstLabel: true,
              showLastLabel: true,
              opposite: true,
              type: 'linear',
              title: {
                text: 'Lifetime(hours)',
                style: {
                  color: "black",
                  fontWeight: 1000
                }
              },
              startOnTick: false,
              lineWidth: 2,

            }],
          tooltip: {
            dateTimeLabelFormats: {
              millisecond: '%m-%d %H:%M:%S.%L',
              second: '%m-%d %H:%M:%S',
              minute: '%m-%d %H:%M',
              hour: '%m-%d %H:%M',
              day: '%Y-%m-%d %H:%M',
              week: '%m-%d',
              month: '%Y-%m',
              year: '%Y'
            }
          },
          credits: {
            enabled: false,
          },
          legend: {
            enabled: true,
            itemMarginTop: 20,
            verticalAlign: 'bottom',
            // layout: 'vertical',
            align: 'middle'
          },
          navigator: {
            // adaptToUpdatedData: false,
            enabled: false
          },
          series: [{
            name: 'Beam Current',
            data: [],
            yAxis: 0,
            lineWidth: 1.5,
            color: "#0055fa",
            showInLegend: false,
            showLegends: false,
          }, {
            name: 'LifeTime',
            data: [],
            yAxis: 1,
            lineWidth: 1.5,
            color: "#FF0000",
            visible: false,
            showInLegend: false,
          }]
        },
        optionsTwo: {
          chart: {
           // backgroundColor: '#000000',
            // plotBackgroundColor:'#000000',
             width: 300,
            // height: 750,
            panning:true
          },
          title: {
            text: null
          },
          xAxis: {
            lineColor: 'grey',
            type: 'line',
            max: 640,
            min: 1,
            startOnTick:true,
            endOnTick:true,
            tickInterval:80
          },
          yAxis:{
            title:'光斑',
            min:0,
            max:480,
            gridLineWidth:0,
            startOnTick:true,
            endOnTick:true,
            tickInterval:80,
            lineWidth:1,
            lineColor: 'grey',
            },
          series: [{
            name: '光斑',
            type: 'scatter',
            data: [{x:1,y:3,color:'rgb(0,0,15)'},{x:2,y:5,color:'rgb(0,0,125)'},{x:635,y:4,color:'rgb(0,0,120)'},{x:640,y:5,color:'rgb(0,0,119)'}],
            turboThreshold:0,
            cropThreshold:300000,
            dataGrouping:{
              enabled:true,
              forced:true,
              //approximation:'average',
              //groupPixelWidth:1
            }
          }]
        },
        timer: null,
        timerguangban:null,
        screenHeight:window.screen.height,
        wrapH:0,
        arrChart:[],
        imgUrl:"/static/img/B8_Beam_IMAGE_direct.png",
        imgUrl:'',
        refreshImg:null
      }
    },
    created(){
      this.initWebpack();
      //this.initWebpackguangban();
    },
    mounted() {
      window.addEventListener('resize',this.handleResize);

     this.wrapH = this.screenHeight -79- 20-20 - 20-20-40 -60;
     this.options.chart.height = 0.32*this.wrapH;
     this.options.chart.width = window.screen.width*0.333*0.85;
     
     this.optionsTwo.chart.width = window.screen.width*0.48*0.6;
     this.optionsTwo.chart.height = 0.32*this.wrapH;

     //console.log(this.wrapH)

      if(this.$route.params.dialogVisible){
        this.$root.$children[0].loginClick();
        this.$root.$children[0].dialogVisible = true
      }
      this.options.series[0].data = [];
      this.options.series[1].data = [];
      let p = new Array();
      let date1 = new Date(Date.now())
      let date2 = new Date(Date.now() - 3600 * 24 * 1000)
      let time1 = date1.format("yyyy-MM-dd hh:mm:ss");
      let time2 = date2.format("yyyy-MM-dd hh:mm:ss");
      let _this = this;
      this.options.yAxis[1].title.text = ""
      // this.options.xAxis.tickPositions = [date2.getTime(),new Date(date2+12*1000*3600).getTime(),date1.getTime()]

      this.$axios.get('/hlsTS/beam/status')
        .then(function (response) {
          let n = response.data['Beam']['BeamCurrent'].length;
          let m = response.data['Beam']['LifeTime'].length;
          let a = [];
          let b = [];
          for (let i = 0; i < n; i++) {
            a.push([new Date(response.data.Beam.BeamCurrent[i].timeStamp.replace(/-/g, '/')).getTime(), response.data.Beam.BeamCurrent[i].value]);
          }
          _this.options.series[0].data = a;
          for (let i = 0; i < m; i++) {
            // if(new Date(response.data.Beam.LifeTime[i].timeStamp.replace(/-/g, '/'))-date2 < 0
            //   || new Date(response.data.Beam.LifeTime[i].timeStamp.replace(/-/g, '/'))-date1 > 0){
            //   break;
            // }
            b.push([new Date(response.data.Beam.LifeTime[i].timeStamp.replace(/-/g, '/')).getTime(), response.data.Beam.LifeTime[i].value]);
          }
          _this.options.series[1].data = b;
        })
      this.timer = setInterval(getIntegralData, 30000);

      function getIntegralData() {
        _this.options.xAxis.max = new Date().getTime()
        _this.options.xAxis.min = new Date(Date.now() - 24 * 1000 * 60 * 60).getTime()
        let p = new Array();
        date1 = new Date(Date.now());
        date2 = new Date(Date.now() - 3600 * 24 * 1000);
        time1 = date1.format("yyyy-MM-dd hh:mm:ss");
        time2 = date2.format("yyyy-MM-dd hh:mm:ss");
        _this.$axios.get('/hlsTS/beam/status')
          .then(function (response) {
            let n = response.data['Beam']['BeamCurrent'].length;
            let m = response.data['Beam']['LifeTime'].length;
            _this.options.series[0].data = [];
            _this.options.series[1].data = [];
            for (let i = 0; i < n; i++) {
              _this.options.series[0].data.push([new Date(response.data.Beam.BeamCurrent[i].timeStamp.replace(/-/g, '/')).getTime(), response.data.Beam.BeamCurrent[i].value]);
            }
            for (let i = 0; i < m; i++) {
              _this.options.series[1].data.push([new Date(response.data.Beam.LifeTime[i].timeStamp.replace(/-/g, '/')).getTime(), response.data.Beam.LifeTime[i].value]);
            }
          })
      }

      this.initWebpack();
      setTimeout(function(){
        _this.initWebpack();
      },1000);

      //this.initWebpackguangban();
      setTimeout(function(){
        //_this.initWebpackguangban();
      },1000);
     //this.timerguangban = setInterval(this.initWebpackguangban, 5000);
     
      this.refreshImg = setInterval(()=>{
        this.imgUrl = `/static/img/B8_Beam_IMAGE_direct.png?t=${Date.now()}`;
      },3000);
    },
    methods: {
      
      handleResize(){
        this.screenHeight = window.screen.height;
      },
      initWebpack: function () {
        let str = window.location.href;
        //let str = 'http://192.168.113.43:8765';
        // str = 'http://192.168.125.222:8090';
        //http://210.45.77.114:8080/home
        // let str = 'http://localhost:8090';
        const wsuri = "ws://" + str.split("/")[2] + "/wsScreen/status";
        // const wsuri = "ws://" + str.split("/")[2] + "/status";
        // const wsuri = "ws://" + str.split("/")[2] + "/status";
        // const wsuri = "ws://"+ '192.168.125.222:8090' + "/status";
        let websock = new WebSocket(wsuri);
        websock.onopen = () => {
          var postValue = {};
          websock.send(JSON.stringify(postValue));
        }
        websock.onmessage = e => {
     
          this.status.energy = null;
          this.status.lifetime = null;
          this.status.beamCurrent = null;
          this.status.operationStatus = null;
          this.status.operationMode = null;

          this.status.exUser = null;
          this.status.proposal = null;
          this.status.start = null;
          this.status.name = null;
          this.status.end = null;
          this.status.p2e = null;
          this.status.io = 0;
          this.status.is = 0;
          this.status.totalBeamtime = null;
          this.status.leftBeamtime = null;
          this.status.bsStatus = null;

          this.status.Hsize = null;
          this.status.Hemittance = null;
          this.status.VSize = null;
          this.status.Vemittance = null;
          this.status.x = null;
          this.status.y = null;

          let data = JSON.parse(e.data)
         //console.log(data)
          //this.status.beamCurrent = parseFloat(data['Current']).toFixed(2).toString() + " mA";
         // if (data['Lifetime'] === 'Infinity') {
            //this.status.lifetime = 'inf' + " hours";
          //} else {
           // this.status.lifetime = parseFloat(data['Lifetime']).toFixed(2).toString() + " hours";
         // }
          //this.status.energy = parseFloat(data['Energy']).toFixed(2).toString() + " MeV";
          //this.status.operationMode = data['OperationMode']
         // this.status.operationStatus = data['OperationStatus']

         const engValue = data.data['RNG:BEAM:CURR'];
         this.status.beamCurrent = engValue !== undefined && engValue !== null ? parseFloat(engValue).toFixed(2).toString() + " mA" : "0.00 mA";

         this.status.beamCurrent = parseFloat(data.data['RNG:BEAM:CURR']).toFixed(2).toString() + " mA";
          if (data.data['RNG:BEAM:LIFE'] === 'Infinity') {
            this.status.lifetime = 'inf' + " hours";
          } else {
            const lifetime = data.data['RNG:BEAM:LIFE'];
            this.status.lifetime = lifetime !== undefined && lifetime !== null ? parseFloat(lifetime).toFixed(2).toString() + " hours" : "0.00 hours";
          }


         const energy = data.data['RNG:ENG'];
         this.status.energy = energy !== undefined && energy !== null ? parseFloat(energy).toFixed(2).toString() + " MeV" : "0.00 MeV";
         
         
         if(data.data['RNG:OPER:MODE'] == "0"){
           this.status.operationMode = "Shutdown"
         }else if(data.data['RNG:OPER:MODE'] == "1"){
           this.status.operationMode = "Commissioning"
         }else if(data.data['RNG:OPER:MODE'] == "2"){
           this.status.operationMode = "Maintenance"
         }else if(data.data['RNG:OPER:MODE'] == "3"){
           this.status.operationMode = "User Operation"
         }else if(data.data['RNG:OPER:MODE'] == "4"){
           this.status.operationMode = "Machine Study"
         }else if(data.data['RNG:OPER:MODE'] == "5"){
           this.status.operationMode = "Beamline Study"
         }
         if(data.data['RNG:OPER:STAT'] == "0"){
           this.status.operationStatus = "Init"
         }else if(data.data['RNG:OPER:STAT'] == "1"){
           this.status.operationStatus = "Shutdown"
         }else if(data.data['RNG:OPER:STAT'] == "2"){
           this.status.operationStatus = "Injection"
         }else if(data.data['RNG:OPER:STAT'] == "3"){
           this.status.operationStatus = "Beam Available"
         }else if(data.data['RNG:OPER:STAT'] == "4"){
           this.status.operationStatus = "Tuning"
         }
        if(data.data['BL12B:BS:Status'] == 0 ||data.data['BL12B:BS:Status'] == 3 ){
           this.status.bsStatus = "故障"
         }else if(data.data['BL12B:BS:Status'] == 1){
           this.status.bsStatus = "开"
         }else if(data.data['BL12B:BS:Status'] == 2){
           this.status.bsStatus = "关"
         }
          this.status.exUser = data.data['XMCDa:Experiment:User'];
          this.status.proposal = data.data['XMCDa:Proposal:number'];
          this.status.start = data.data['XMCDa:Beamtime:Start'];
          this.status.name = data.data['XMCDa:Proposal:Name'];
          this.status.end = data.data['XMCDa:Beamtime:End'];

        
          this.status.p2e = data.data['BL12B:P2E'] !== undefined && data.data['BL12B:P2E'] !== null ? Number(data.data['BL12B:P2E']).toFixed(2) : 0;

          this.status.io = data.data['BL12B:I0'] !== undefined && data.data['BL12B:I0'] !== null ? Number(data.data['BL12B:I0']).toExponential(2) : 0;

          this.status.is = data.data['BL12B:Is'] !== undefined && data.data['BL12B:Is'] !== null ? Number(data.data['BL12B:Is']).toExponential(2) : 0;

          this.status.totalBeamtime = data.data['total_beamtime']+ " hours";
          this.status.leftBeamtime = data.data['left_beamtime'] + " hours";

        
          this.status.Hsize = data.data['SR-BD-B8:H:SIZE'] !== undefined && data.data['SR-BD-B8:H:SIZE'] !== null ? Number(data.data['SR-BD-B8:H:SIZE']).toFixed(2)+ " mm" : 0;
          this.status.Hemittance = data.data['SR-BD-B8:H:EMITTANCE:AVG'] !== undefined && data.data['SR-BD-B8:H:EMITTANCE:AVG'] !== null ? Number(data.data['SR-BD-B8:H:EMITTANCE:AVG']).toFixed(2)+ " nmrad" : 0;
          this.status.VSize = data.data['SR-BD-B8:V:SIZE'] !== undefined && data.data['SR-BD-B8:V:SIZE'] !== null ? Number(data.data['SR-BD-B8:V:SIZE']).toFixed(2)+ " mm" : 0;
          this.status.Vemittance= data.data['SR-BD-B8:V:EMITTANCE'] !== undefined && data.data['SR-BD-B8:V:EMITTANCE'] !== null ? Number(data.data['SR-BD-B8:V:EMITTANCE']).toFixed(2)+ " nmrad" : 0;
          this.status.x = data.data['RNG:IVU:BPM:BPM4:X'] !== undefined && data.data['RNG:IVU:BPM:BPM4:X'] !== null ? Number(data.data['RNG:IVU:BPM:BPM4:X']).toFixed(2)+ " mm" : 0;
          this.status.y = data.data['RNG:IVU:BPM:BPM4:Y'] !== undefined && data.data['RNG:IVU:BPM:BPM4:Y'] !== null ? Number(data.data['RNG:IVU:BPM:BPM4:Y']).toFixed(2)+ " mm" : 0;
        }
        websock.onclose = function () {
          // 关闭 websocket
        }
        // 路由跳转时结束websocket链接
        this.$router.afterEach(function () {
          websock.close()
        })
        websock.onerror = function () {
          console.log("error occurred")
        }
      },
      initWebpackguangban: function () {
        let _this = this;
        let str = window.location.href
        //let str = 'http://192.168.113.43:8765';
        const wsuri = "ws://" + str.split("/")[2] + "/wsScreen/status";
        let websock = new WebSocket(wsuri);
        websock.onopen = () => {
          var postValue = {
            command:"request_full_image"
          };
          websock.send(JSON.stringify(postValue));
        }
        websock.onmessage = e => {
          let data = JSON.parse(e.data)
          if(data.type == 'full_image_data'){
            // 关闭 websocket
            let arrTotal = data.data;
            let length = arrTotal.length;
            let xlen = 480;
            let ylen = 640;
            _this.arrChart = [];
            for( let i = 479;i > 0; i--){
              for(let j = 0;j< ylen; j++){
                let arr = {x:j,y:i,color:`rgb(0,0,${arrTotal[ylen * (479-i)+ (j)]})`};
               _this.arrChart.push(arr);
              }
            }
             _this.optionsTwo.series[0].data = _this.arrChart;
          }
        }
        websock.onclose = function () {
          // 关闭 websocket
        }
        // 路由跳转时结束websocket链接
        this.$router.afterEach(function () {
          websock.close()
        })
        websock.onerror = function () {
          console.log("error occurred")
        }
      },


      addLifeTime: function () {
        if (this.switchValue1 === true) {
          this.options.series[1].visible = true
          this.options.yAxis[1].title.text = "Lifetime(hours)"
        } else {
          this.options.series[1].visible = false
          this.options.yAxis[1].title.text = ""
        }
      },
    },
    beforeDestroy(){
      window.removeEventListener('resize',this.handleResize)
      clearInterval(this.refreshImg)
    },
    destroyed() {
      clearInterval(this.timer);
      clearInterval(this.timerguangban);
    }
  }
</script>
<style scoped>
  div {
    margin-left: auto;
    margin-right: auto;
  }
  .block{
    height: 500px;
    border-radius: 20px;
    background: rgba(204,204,204,0.4);
    margin: 0.9%;
    border:1px solid black;
  }
  .title{
    margin-bottom: 20px;
    margin-top: 20px;
    font-size:50px;
  }
  .bigtitle{
     margin-bottom: 20px;
      margin-top: 20px;
      text-align: center;
      font-size: 60px;
  }
  .top-ul{
    overflow: hidden;
  }
  .shiyanUl{
    color: rgb(0, 68, 153);
    font-size: 27px;
    display: flex;
    justify-content: center;
  }
  .shiyanli{
    overflow: hidden;
    line-height: 60px;
  }
  .shiyanliLeft{
    float: left;
  }
  .shiyanliRight{
    float: left;
  }
  .shiyanliname{float: left;}
  .shiyanlitxt{color: rgb(138, 43, 226);float:left;}
  .longtxt{
    font-size:27px;
    text-align: left;
    overflow-wrap: break-word;
    word-break: break-word;
    white-space: normal;
    color: rgb(138, 43, 226);
    position: absolute;
    top: 87%;
    left: 36%;
    width: 68%;
  }
  .shiyanname{
    width: 300px; 
    font-size: 30px;
  }
  .box{position: relative;}
  .boxLeft{
    float: left;
    width: 33.3%;
  }
  .boxRight{
    float: left;
    width: 33.3%;
  }
  .boxMiddle{
    float: left;
    width: 33.3%;
  }
</style>



// WEBPACK FOOTER //
// src/page/activePublic/operationStatus.vue